import { FormField, Pagination, Table } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useState } from 'react';
import { addNotification, buildBreadcrumbItems, formatCurrency, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
import { useRouter } from '../../../router';
import { useStore } from '../../../store';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import Favorites from '../../../../../components/extras/Favorites';
import SelectPaging from '../../../../../components/selects/selectPaging';
import SelectUser from '../../../../../components/selects/selectUser';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';

const pageSize = 20;

export const AdminMovementsCasinoPage = () => {
  //const storeAdmin = useStoreAdmin();

  const { menu, parameters, data } = useGlobalState();
  const {
    actions: { makeHelpPanelHandler },
  } = useStore();
  const { navigate } = useRouter();


  const [movements, setMovements] = useState<any[]>([]);
  const [balanceCasino, setBalanceCasino] = useState<number>(0);
  const [currentPageIndex, setCurrentPageIndex] = useState(1);
  const paginated = movements.slice((currentPageIndex - 1) * parameters.pageSize, currentPageIndex * parameters.pageSize);



  useEffect(() => {
    setMovements([]);
    handleRefreshMovements();
  }, [parameters?.idUser]); //parameters.startDate, parameters.endDate, 




  const handleRefreshMovements = async () => {
    //if (parameters.startDate && parameters.endDate) { 
    if (parameters.idUser && parameters.idUser > 0) {

      try {
        setLoading(true)
        const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-routing': '/private/admin/movements/casino/list',
            'JWT': getCookie("JWT"),
            //  
          },
          body: JSON.stringify(
            {
              limit: 100,
              orderBy: "dateMovement",
              order: "desc",
              idUser: parameters.idUser
            }
          ),
          //mode: 'no-cors'  // Bypasses CORS but limits the response
        });

        if (!response.ok) {
          throw new Error(`HTTP error: ${response.status}`);
        }
        const dataWeb = await response.json();
        if (dataWeb.code == 0) {
          setMovements(dataWeb.movements);
          setBalanceCasino(dataWeb.balanceCasino);
        } else {
          addNotification(dataWeb.status, 'error', setData);
        }
      } catch (error: any) {
        addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
      } finally { setLoading(false) }

    };
  }
  return (
    <CustomAppLayout
      toolsHide

      contentType="form"
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <>
          <SpaceBetween direction="vertical" size="xs">

            <Header
              description={<>Listado de movimientos de la cuenta casino para cargos y depósitos</>}
              actions={
                <SpaceBetween direction="horizontal" size="xs">

                  <Favorites />
                </SpaceBetween>
              }
            >
              Cartola cuenta casino
            </Header>

            <Table
              header={
                parameters?.idUser && (
                  <>Saldo actual es de <strong>{formatCurrency(balanceCasino, "CLP")}</strong>.</>
                )
              }

              pagination={

                <SpaceBetween direction="horizontal" size="xs" alignItems="center">
                  {movements.length > parameters.pageSize && (
                    <Pagination
                      currentPageIndex={currentPageIndex}
                      pagesCount={Math.ceil(movements.length / parameters.pageSize)}
                      onChange={({ detail }) => setCurrentPageIndex(detail.currentPageIndex)}
                    />
                  )}

                  {movements.length > 0 && movements.length > parameters.pageSize && (
                    <SelectPaging onSelect={(pageSize) => {
                      setCurrentPageIndex(1);
                      setParameters({ ...parameters, pageSize: pageSize });
                    }} />
                  )}
                </SpaceBetween>
              }
              filter={
                <SelectUser
                  value={parameters.idUser}
                  onConfirm={(user) => {
                    if (user)
                      setParameters((prev) => ({
                        ...prev,
                        idUser: user.idUser
                      }));
                    else
                      setParameters((prev) => ({
                        ...prev,
                        idUser: 0
                      }));
                  }}
                />
              }
              cellVerticalAlign='top'
              stickyHeader
              variant="embedded"
              columnDefinitions={[
                {
                  id: "dateTransaction",
                  header: "Fecha",
                  width: 120,
                  cell: item => <FormField label={item.dateMovement}>{item.year}</FormField>
                },
                {
                  id: "data",
                  header: "Glosa",
                  cell: item => item.ammount > 0 ? "Abono Cta Casino desde Cta CPV" : "Pago Cta Socio a Casino"
                },
                {
                  id: "exp",
                  header: "Expiración",
                  cell: item => (
                    <FormField label={item.ammount > 0 ? item.dateExpires : ""}>
                      {item.ammount > 0 && item.isExpired === 0 ?
                        `Saldo: ${formatCurrency(item.balanceNonExpired, "CLP")}` : ""}
                    </FormField>

                  )
                },
                {
                  id: "ammount",
                  header: "Monto",
                  cell: item => item.ammount.toLocaleString('es-CL', {
                    style: 'currency',
                    currency: 'CLP',
                    maximumFractionDigits: 0
                  }),
                },
              ]}
              items={paginated}
            />
          </SpaceBetween>
        </>
      }
    />
  );
};
